import { render, staticRenderFns } from "./InterfaceSpe.vue?vue&type=template&id=0c47ae7b&scoped=true&"
import script from "./InterfaceSpe.vue?vue&type=script&lang=js&"
export * from "./InterfaceSpe.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceSpe.vue?vue&type=style&index=0&id=0c47ae7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c47ae7b",
  null
  
)

export default component.exports